module.exports = __webpack_public_path__ + "static/media/sport.74acef3c.jpg";